import { Flex } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import {
  FacingHorizontalIcon,
  FacingVerticalIcon,
  FacingsHuIcon,
  FacingsSuIcon,
} from "ui/Icons/Icons";
import { TitleXS } from "ui/Typography/Typography";
import { isNullOrUndefined } from "utils/tsHelpers";

export interface ProductFacingProps {
  numberOfFacings: number | null;
  numberOfStacking?: number | null;
  isShelvedInHandlingUnits: boolean | null;
  withTopSpacing?: boolean;
}

export function ProductFacing({
  numberOfFacings,
  numberOfStacking,
  isShelvedInHandlingUnits,
  withTopSpacing = true,
}: ProductFacingProps) {
  const intl = useIntl();

  const isMissingInfo = !numberOfFacings || isNullOrUndefined(isShelvedInHandlingUnits);

  if (isMissingInfo) {
    return (
      <TitleXS data-testid="facings-quantity">
        {intl.formatMessage({ id: "components.product-facing.lable.facings" })} N/A
      </TitleXS>
    );
  }

  const { Icon, label, color, chipBg, width } = isShelvedInHandlingUnits
    ? {
        label: intl.formatMessage(
          {
            id: "components.product-facing.lable.handling-units",
          },
          { count: 0 },
        ),
        color: "orange.500",
        chipBg: "orange.100",
        width: "21px",
        Icon: FacingsHuIcon,
      }
    : {
        label: intl.formatMessage(
          { id: "components.product-facing.lable.single-units" },
          { count: 0 },
        ),
        color: "marine.500",
        chipBg: "marine.100",
        width: "9px",
        Icon: FacingsSuIcon,
      };

  return (
    <Flex
      gap="s100"
      alignItems="center"
      mt={withTopSpacing ? "s100" : undefined}
      px="s100"
      py="s50"
    >
      <Icon color={color} width={width} data-testid="facings-title" />
      <TitleXS data-testid="facings-unit-type">{label}</TitleXS>
      <Flex
        bg={chipBg}
        borderRadius="sm"
        px="s50"
        py="2px"
        gap="s25"
        alignItems="center"
        data-testid="facings-horizontal-chip"
      >
        <FacingHorizontalIcon color={color} height="14px" />
        <TitleXS color={color} data-testid="facings-horizontal-quantity">
          {numberOfFacings}
        </TitleXS>
      </Flex>
      {!isNullOrUndefined(numberOfStacking) && (
        <Flex
          bg={chipBg}
          borderRadius="sm"
          px="s50"
          py="2px"
          gap="s25"
          alignItems="center"
          data-testid="facings-vertical-chip"
        >
          <FacingVerticalIcon color={color} boxSize="14px" />
          <TitleXS color={color} data-testid="facings-vertical-quantity">
            {numberOfStacking}
          </TitleXS>
        </Flex>
      )}
    </Flex>
  );
}
